import React, { useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { Popover } from '@mui/material';

import SubNavbar from '../components/SubNavbar';
import { openPricingModal } from '../../../sagas/pricingModal/actions';
import { getRouteName } from '../../../utils/routesNames';

import './_discoverNav.scss';

const DiscoverNav = () => {
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const [autoConnectPopoverAnchor, setAutoConnectPopoverAnchor] = useState(null);
  const autoConnectPopoverPaperRef = useRef(null);
  const billingSubscriptionInfo = useSelector(s => s.getBillingSubscriptionInfo);
  const canAccessAutoDiscover = Boolean(billingSubscriptionInfo.data?.can_auto_discover);

  const handleAutoConnectBadgeHover = event => {
    if (!canAccessAutoDiscover && event.currentTarget) {
      setAutoConnectPopoverAnchor(event.currentTarget);
    } else {
      setAutoConnectPopoverAnchor(null);
    }
  };

  const handleAutoConnectPopoverClose = () => {
    setAutoConnectPopoverAnchor(null);
  };
  
  return (
    <div className="discoverNav">
      <SubNavbar route={getRouteName(pathname)}>
        <div
          className={`discoverNav-autoConnectionBadge ${canAccessAutoDiscover ? 'active' : 'locked'}`}
          onMouseEnter={handleAutoConnectBadgeHover}
        >
          <div className="status-dot-wrap">
            <div className="status-dot" />
          </div>
          <div className="badge-text">
            <span className="title">Auto-Connection</span>
            <span className="state">{` · ${canAccessAutoDiscover ? 'Active' : 'Locked'}`}</span>
          </div>
        </div>
      </SubNavbar>
      <Popover
        open={Boolean(autoConnectPopoverAnchor)}
        anchorEl={autoConnectPopoverAnchor}
        onClose={handleAutoConnectPopoverClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center'
        }}
        PaperProps={{
          ref: autoConnectPopoverPaperRef,
          onMouseLeave: handleAutoConnectPopoverClose,
          style: {
            borderRadius: '16px'
          }
        }}
        disableRestoreFocus
      >
        <div className="discoverNav-autoConnect-popover">
          <div className="popover-container">
            <div className="popover-content">
              <div className="popover-icon">
                <div className="icon-circle" />
                <div className="icon-star">★</div>
              </div>
              <div className="popover-text">
                <div className="popover-title">Auto-Connection is a Pro feature</div>
                <div className="popover-subtitle">
                  Upgrade to Pro to automatically invite relevant creators to grow your network
                </div>
              </div>
            </div>
            <button
              className="popover-button"
              onClick={() => {
                dispatch(openPricingModal());
                handleAutoConnectPopoverClose();
              }}
            >
              Upgrade to Pro
            </button>
          </div>
        </div>
      </Popover>
    </div>
  );
};

export default DiscoverNav;